import { IDriverUser } from '../../types/type';
import AutoCard from '../AutoCard/AutoCard';

function AutoInfoCard({ user }: { user: IDriverUser }) {
  return (
    <div className="" style={{ marginBottom: '25px' }}>
      {user.cars.map((car, index) => (
        <AutoCard car={car} key={index} carLength={user.cars.length} />
      ))}
    </div>
  );
}

export default AutoInfoCard;
